// Возвращает true, если тестируемый символ принадлежит к русскому или 
// английскому алфавиту и false в противном случае
export function isNotChar(sym) {
	return !/[a-zA-Zа-яА-ЯёЁ]/.test(sym);
};

// Возвращает true, если тестируемая последовательность символов (str) 
// находящаяся на заданной позиции (pos) в целевой строке (source)
// не окружена символами русского или английского алфавита и false в противном случае
export function isStandAlone(str, source, pos){
  let isAlone = true;

  if(pos !== 0) {
    if( !isNotChar(source.charAt(pos-1)) ) isAlone = false; 
  }
  if((pos+str.length) < source.length-1 ){
    if( !isNotChar(source.charAt(pos+str.length)) ) isAlone = false;
  } 

  return isAlone;  
};

// Возвращает true, если тестируемая последовательность символов (str) 
// находящаяся на заданной позиции (pos) в целевой строке (source)
// не находится внутри тега, т.е. между символами < и >, и false в противном случае
export function isNotInTag(str, source, pos){
  let isNotInTag = true;
  let openTagPos;
  let closeTagPos;

  if( pos===0 || (pos+str.length)>=(source.length-1) ) return isNotInTag;
  let openTagBefore = false;
  let closeTagAfter = false;

  // Проверяем наличие и расположение отрывающих/закрывающих скобок до
  openTagPos = source.lastIndexOf('<', pos);
  closeTagPos = source.lastIndexOf('>', pos);

  openTagBefore = openTagPos !== -1;
  openTagBefore = openTagBefore && closeTagPos < openTagPos
  
  // Проверяем наличие и расположение отрывающих/закрывающих скобок после
  openTagPos = source.indexOf('<', pos+str.length);
  closeTagPos = source.indexOf('>', pos+str.length);

  closeTagAfter = closeTagPos !== -1;
  closeTagAfter = closeTagAfter && openTagPos !== -1;
  closeTagAfter = closeTagAfter && closeTagPos < openTagPos;

  if(openTagBefore && closeTagAfter) isNotInTag = false

  return isNotInTag;
};

// Ищет все вхождения в целевую строку (text) из заданного массива строк (words) и возвращает массив объектов вида: 
// 		{pos: <позиция в целевой строке (text)>, word:<найденное слово из заданного массива>}
// упорядоченный в обратном порядке по свойству pos. 
// В зависимости от значения параметра mode поиск производится по разному:
// при значении 'alone' - слово должно быть в тексте отдельно, при любом другом значении 
// параметра слово может быть подстрокой другого слова
export function getMatches(words, text, mode) {
  let arr = [];
  let sourceStr = text.toLowerCase()

  words.forEach( str => {
    let pos = 0;
    let target = str.toLowerCase();
    let watchDogStop = false;
    let watchDogId = setTimeout(() => {watchDogStop = true;}, 30000);
    
    while (true) {
    	if( watchDogStop ) break;

      let foundPos = sourceStr.indexOf(target, pos+1);
      
      if (foundPos == -1) break;
      pos = foundPos;
      if( !isNotInTag(str, sourceStr, foundPos) ) continue;
      if( mode === 'alone' && !isStandAlone(str, sourceStr, pos)) continue;
      arr.push({
        pos:foundPos,
        word: str
      });
    }
    clearTimeout(watchDogId);
  });
  arr = arr.sort((a, b) => (a.pos < b.pos)? 1: -1)

  return arr
};

export function getMatchesForPhrases(wordsArr, text) {
  let arr = [];
  let sourceStr = text.toLowerCase()

  wordsArr[0].forEach( word => {
    let pos = 0;
    let target = word.toLowerCase();
    let watchDogStop = false;
    let watchDogId = setTimeout(() => {watchDogStop = true;}, 30000);
    
    while (true) {
      if( watchDogStop ) break;

      let foundPos = sourceStr.indexOf(target, pos+1);
      
      if (foundPos == -1) break;
      pos = foundPos;

      // Проверяем, что слово не внутри тега и не входит подстрокой в другое слово
      if( !isNotInTag(word, sourceStr, foundPos) || !isStandAlone(word, sourceStr, pos) ) {
        continue;
      } 

      // Ищем идут ли за ним слова из последовательности найденных массивов словоформ
      // для фразы в поиске
      let newPos = pos
      let wordShift = word.length
      let isInPhrase = true

      for(let i = 1; i < wordsArr.length; i++) {
        newPos += wordShift
        let afterWord = text.slice(newPos).match(/[a-zа-яё]+/i)

        if(afterWord === null) {
          isInPhrase = false
          break
        } 
        let newWordIndex = wordsArr[i].findIndex(item => item === afterWord[0].toUpperCase())

        if( newWordIndex === -1 ) {
          isInPhrase = false
          break
        }
        newPos = text.toUpperCase().indexOf(wordsArr[i][newWordIndex], newPos+1)
        wordShift = wordsArr[i][newWordIndex].length
      }
      if( !isInPhrase ) continue

      let str = text.slice(foundPos, newPos + wordShift)

      arr.push({
        pos:foundPos,
        word: str
      });
    }
    clearTimeout(watchDogId);
  });
  arr = arr.sort((a, b) => (a.pos < b.pos)? 1: -1)

  return arr 
}

// Размечает найденные функцией getMatches значенияб окружая каждое открывающим (openTag) 
// и закрывающим (closeTag) тегами. В качестве открывающего тега может быть передана
// функция для формирования уникальных идентификаторов на основании индекса вхождения 
// в передаваемом массиве (matches) 
export function markTextWithMatches( matches, text, openTag, closeTag) {
  if( !matches.length) return text;

  let charArr = text.split('');

  matches.forEach( (item, k) => {
    const index = matches.length - k;

    charArr.splice(item.pos + item.word.length, 0, closeTag);
    charArr.splice(item.pos, 0, typeof(openTag) === 'function'? openTag(index): openTag);
  })

  return charArr.join('');      
};
